import * as React from 'react';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { default as CheckIcon } from '@material-ui/icons/Check';
import ListItemText from '@material-ui/core/ListItemText';
import MenuList from '@material-ui/core/MenuList';
import { StyledMenuItem } from './BaseMapSelect';
const WmsMapSelect = (props) => {
    const { selectedLayer, mapLayers, onLayerChange } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(MenuList, null, mapLayers.map((layer, index) => {
            const selected = index === selectedLayer;
            return (React.createElement(StyledMenuItem, { key: layer.label, selected: selected, onClick: () => onLayerChange(index) },
                selected && (React.createElement(ListItemIcon, null,
                    React.createElement(CheckIcon, { fontSize: "small" }))),
                React.createElement(ListItemText, { primary: layer.label })));
        }))));
};
export default WmsMapSelect;
